import { jsx as _jsx } from "react/jsx-runtime";
import { AnonymousUserContent } from "@sista/fe-commons";
import { IdmClientContext } from "@sista/idm-client";
import { useContext } from "react";
import { LoggedUserContent } from "./LoggedUserContent/LoggedUserContent";
export const Content = () => {
    const { loggedAccount } = useContext(IdmClientContext);
    return loggedAccount ? _jsx(LoggedUserContent, {}) : _jsx(AnonymousUserContent, {});
};
